import {
  commonProperties,
  newsletterIdString,
  salesForceCampaignId,
  salesforceProducts,
  finePrintOverride,
  customProperties,
  MENU,
  SUB_MENU,
  MENU_ITEM,
  SEARCH_FILTER,
  SEARCH_FILTER_SORT,
  RESTRICTED_USER_UPDATE_FORM,
  REGISTRATION_FORM,
  MODAL
} from '../constants';

export const restrictedUserUpdateForm = {
  type: RESTRICTED_USER_UPDATE_FORM,
  name: 'Restricted user update form',
  icon: 'fa-circle',
  settings: {},
  formSchema: {
    properties: {
      ...commonProperties,
      newsletterIdString,
      salesForceCampaignId,
      salesforceProducts,
      finePrintOverride,
      customProperties
    }
  },
  allowChildren: true,
  notAllowedChildrenTypes: [
    MENU,
    SUB_MENU,
    MENU_ITEM,
    SEARCH_FILTER,
    SEARCH_FILTER_SORT,
    RESTRICTED_USER_UPDATE_FORM,
    REGISTRATION_FORM,
    MODAL
  ],
  color: 'blue',
  group: 'ui'
};
